import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import io from "socket.io-client";

import { useAuth } from '../services/authentication/authentication.context';
import { AppHeader } from '../components/header/header';
import { formatUrl } from '../_helpers/parseurl';
import { appConfigs } from '../services/config';
import "../styles/classroom.css";

export const GlobalClassroom = () => {

    const { user, accounts } = useAuth();
    const token = useAuth()?.token;
    const { serverUrl } = appConfigs;

    const [currentMsg, setCurrentMsg] = useState();
    const [chatMessages, setChatMessages] = useState([]);
    const [peer, setPeer] = useState();
    const [onlineUsers, setOnlineUsers] = useState();
    const [onLineAccounts, setOnlineAccounts] = useState([]);
    const [isList, setIsList] = useState(true);
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [messages, setMessages] = useState([]);
    const [authStatus, setAuthStatus] = useState('');

    /** update message object */
    const appendMessage = (msg) => {
        setMessages((prevMessages) => [...prevMessages, msg]);
    };




    // const createRoom = (roomName) => {
    //     // Initialize Socket.IO connection with the JWT token in the `auth` object
    //     const newSocket = io(serverUrl, {
    //         query: {
    //             token: token,
    //         }
    //     });
    //     newSocket.emit('createGroup', (roomName));
    // }


    // 




    const sendMessage = (recipient, message) => {
        socket.emit('privateMessage', ({ recipient, message }));
    }


    // Refactored code to prevent infinite renders
    useEffect(() => {
        // This effect runs only when token or serverUrl changes
        if (!token) {
            return console.log({ error: 'No token found' });
        };
        // Use `auth` object for Socket.IO authentication
        // Note: It's better to use the 'auth' object as specified by Socket.IO for authentication,
        // rather than 'query', which is often for non-secure handshake data.
        const newSocket = io(serverUrl, {
            query: {
                token: token,
            }
        });

        // --- Socket Event Listeners ---
        newSocket.on('connect', () => {
            setIsConnected(true);
            setAuthStatus('Connected');
            setMessages((m) => ([...m, '🔌 Socket connected...']));
        });

        newSocket.on('authStatus', (data) => {
            setAuthStatus(data.authorized ? 'Authorized' : 'Unauthorized');
            setMessages((m) => ([...m, `📝 Server Auth Status: ${data.message}`]));
        });

        newSocket.on('message', (msg) => {
            setMessages((m) => ([...m, `💬 Server Message: ${msg}`]));
        });

        newSocket.on('connect_error', (err) => {
            setIsConnected(false);
            setAuthStatus('Connection Error');
            setMessages((m) => ([...m, `❌ Connection Error: ${err.message}`]));
            console.error('Socket connection error:', err);
        });

        newSocket.on('disconnect', (reason) => {
            setIsConnected(false);
            setAuthStatus('Disconnected');
            setMessages((m) => ([...m, `🔌 Socket Disconnected: ${reason}`]));
        });

        // Update online user list listener
        newSocket.on('updateUserList', (userlist) => {
            setOnlineUsers(userlist);
            console.log(userlist);
        });

        // Listen to private messages
        newSocket.on('pvmessage', (data) => {
            let mesg = data?.message;
            let sender = data?.sender;
            setChatMessages((msg) => ([...msg, mesg]))
        });

        // Set the socket instance once, after the listeners are attached
        setSocket(newSocket);

        // Cleanup function: disconnect the socket when the component unmounts
        // or when the dependencies (token, serverUrl) change.
        return () => {
            newSocket.disconnect();
        };
    }, [token, serverUrl]);

    // Use a separate useEffect to handle logic that depends on 'socket'
    // and 'user', so it runs only when they change.
    useEffect(() => {
        // Emit 'join' event after the socket is connected and user is available
        socket?.emit('join', user?.username);

    }, [socket, user]);

    // Use another separate useEffect to handle updating online accounts.
    // This runs only when `onlineUsers` or `accounts` change.
    useEffect(() => {
        if (accounts && onlineUsers) {
            const listO = accounts.filter((account) => onlineUsers.includes(account.username));
            setOnlineAccounts(listO);
            //console.log(onLineAccounts);
        }
    }, [accounts, onlineUsers]);

    // All other functions like connectSocket, disconnectSocket, and goOnline are now
    // unnecessary as they are handled by the useEffect hooks.



    // Re-run effect if socket instance changes

    return (
        <div className='flx-c'>
            <AppHeader />
            <div className='room-container'>

                <div className={classNames('u-list', { 'sel': !isList })}>
                    {onLineAccounts?.map((acc, k) => (
                        <div
                            className='list-unit'
                            onClick={() => {
                                setPeer(acc);
                                setIsList((l) => !l)
                            }}
                            key={k}
                        >
                            <img
                                src={formatUrl(acc?.avatar)}
                                className='user-avatar'
                                alt=''
                            />
                            <div className={classNames('user-data', 'flx-v')}>
                                <div className='user-nm'>{acc.username}</div>
                                <div className='user-last'></div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={classNames('r-act', { 'sel': isList })}>
                    {!peer ?
                        <div className={classNames('no-act', 'flx-c-v')}>
                            <h1>Global Classroom</h1>
                            <h5 className={classNames('stat', { 'conn': isConnected })} >
                                {isConnected ? "You're online" : "You're offline"}
                            </h5>
                        </div> :
                        <div className='act-pg'>
                            <div className={classNames('act-user')}>
                                <div className={classNames('list-unit')}>
                                    <img
                                        src={formatUrl(peer?.avatar)}
                                        className='user-avatar'
                                        alt=''
                                    />
                                    <div className={classNames('user-data', 'flx-v')}>
                                        <div className='user-nm'>{peer?.username}</div>
                                        <div className='user-last'></div>
                                    </div>
                                    <div className='back-box'>
                                        <button className='trnsp' onClick={() => setIsList((l) => !l)}>
                                            <FontAwesomeIcon icon={faArrowLeftLong} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='msgs'>
                                {chatMessages?.map((msg, k) => (
                                    <div className='my-mesg' key={k}>{msg}</div>
                                ))}
                            </div>
                            <div className={classNames("chat-input", 'inbox-input')}>
                                <div
                                    className={classNames("chat-input-box", 'tr-box')}
                                    contentEditable
                                    onBlur={(e) => setCurrentMsg(e.currentTarget.innerText)}
                                    dangerouslySetInnerHTML={{ __html: currentMsg }}
                                />


                                <button
                                    className="chat-send"
                                    onClick={() => {
                                        setChatMessages((msgs) => ([...msgs, currentMsg]));
                                        sendMessage('berserker22', currentMsg);
                                        setCurrentMsg('');
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPaperPlane} />
                                </button>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    );
}